import { format, startOfMonth } from 'date-fns';

export const dateRules = {
  required: 'Data é obrigatório!',
  pattern: {
    value: /^[0-3][0-9]\/[0-1][0-9]\/[0-9][0-9][0-9][0-9]$/,
    message: 'Data inválida! (dd/MM/aaaa)'
  }
};

export const getDateBegin = () => {
  const date = new Date();
  const firstDayMonth = new Date(
    date.getFullYear('pt-br'),
    date.getMonth('pt-br'),
    1
  );
  const dateBegin = format(startOfMonth(firstDayMonth), 'dd/LL/yyyy');
  return dateBegin;
};

export const manageEditable = (itemIndex, data, setData) => {
  const copyData = [...data];
  copyData.map((item, index) => {
    if (index === itemIndex) {
      item.editable = !item.editable;
    }
  });
  setData(copyData);
};

export const manageValue = (
  id,
  value,
  discount,
  amount,
  data,
  setData,
  index
) => {
  const copyData = [...data];

  copyData.map((item, mapIndex) => {
    if (id === item.id && mapIndex === index) {
      item.value = value;
      item.discount = discount;
      item.amount = amount;
    }
  });

  setData(copyData);
};

export const manageAmount = (
  amount,
  data,
  setData,
  index,
  manageDispatch,
  entrada
) => {
  const copyData = [...data];

  if (amount > 0 && entrada >= 0) {
    copyData[index].amount = amount;
    copyData[index].entrada = entrada;
  }

  setData(copyData);
  manageDispatch(copyData);
};

export const formatter = (input) => {
  let formattedInput = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(input);

  return formattedInput;
};

export const checkFormat = (input) => {
  if (input.startsWith('R$') === false) {
    input = `R$ ${input}`;

    return input;
  } else {
    return input;
  }
};

export const maskOnlyNumbers = (event) => {
  let exibValue = event;
  exibValue = exibValue.replace(/\D/g, '');
  exibValue = exibValue.replace(/(\d)(\d{2})$/, '$1,$2');

  let formatedValue = exibValue;

  formatedValue = formatedValue.replace(',', '.');
  formatedValue = parseFloat(formatedValue);

  exibValue = exibValue.replace(/(?=(\d{3})+(\D))\B/g, '.');
  event = exibValue;

  return { formatedValue: formatedValue, exibValue: exibValue };
};

export const clearForm = (reset, setData, setConta, setSocketAccountName) => {
  reset();
  setData([]);
  setConta({});
  setSocketAccountName({});
};
